<div class="container">
    <div class="row">
        <h2>Ingreso Empresa.</h2>
    </div>
    <div class="row mb-3">
        <p class="lead">
            Ingrese rut de empresa a la cual asignar representate legal.
        </p>
    </div>
    <form class="row g-3" autocomplete="off" [formGroup]="formulario" (ngSubmit)="inserteEmpr();" >
        <div class="mb-3 col-6">
            <label for="rut" class="form-label">Rut Empresa</label>
            <div class="input-group">
                <div class="col-auto"><input formControlName="rut" id="rut" class="form-control"></div> <span class="input-group-text">-</span> <div class="col-1"><input formControlName="dv" id="dv" class="form-control"></div>
            </div>
            <div id="rutHelp" class="form-text">Ingresa rut de Empresa a la cual se asignará el representante legal.</div>
        </div>
        <div class="mb-3 col-6">
            <label for="razonSocial" class="form-label">Razón Social</label>
            <input formControlName="razonSocial" id="razonSocial" class="form-control">
            <div id="razonSocialHelp" class="form-text">Ingresa razon social.</div>
        </div>
        <div class="mb-3 col-6">
            <label for="calle" class="form-label">Calle</label>
            <input formControlName="calle" id="calle" class="form-control">
            <div id="calleHelp" class="form-text">Ingresa razon social.</div>
        </div>
        <div class="mb-3 col-6">
            <label for="nro" class="form-label">Número Dirección</label>
            <input formControlName="nro" id="nro" class="form-control">
            <div id="nroHelp" class="form-text">Nombre del Representante.</div>
        </div> 
        <div class="mb-3 col-6">
            <label for="nroDepto" class="form-label">Número Depto.</label>
            <input formControlName="nroDepto" id="nroDepto" class="form-control">
            <div id="nroDeptoHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-6">
            <label for="region" class="form-label">Región</label>
            <select class="form-select" id="region" formControlName="region">
                <option *ngFor="let regiones of regionesLov" [value]="regiones.CODE_CDG">{{ regiones.CODE_DESC }}</option>
            </select>
            <div id="regionHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-6">
            <label for="ciudad" class="form-label">Ciudad</label>
            <select class="form-select" id="ciudad" formControlName="ciudad">
                <option *ngFor="let ciudades of ciudadesLov" [value]="ciudades.CODE_CDG">{{ ciudades.CODE_DESC }}</option>
            </select>
            <div id="ciudadHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-6">
            <label for="comuna" class="form-label">Comuna</label>
            <select class="form-select" id="comuna" formControlName="comuna">
                <option *ngFor="let comunas of comunasLov" [value]="comunas.CODE_CDG">{{ comunas.CODE_DESC }}</option>
            </select>
            <div id="comunaHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-6">
            <label for="correo" class="form-label">Correo</label>
            <input formControlName="correo" id="correo" class="form-control">
            <div id="correoHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-6">
            <label for="correoCon" class="form-label">Correo Confirmación</label>
            <input formControlName="correoCon" id="correoCon" class="form-control">
            <div id="correoConHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-2">
            <label for="fonoArea" class="form-label">Aréa de Telefono</label>
            <input formControlName="fonoArea" id="fonoArea" class="form-control">
            <div id="fonoAreaHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-4">
            <label for="fono" class="form-label">Telefono</label>
            <input formControlName="fono" id="fono" class="form-control">
            <div id="fonoHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-2">
            <label for="celuArea" class="form-label">Aréa de Celular</label>
            <input formControlName="celuArea" id="celuArea" class="form-control">
            <div id="celuAreaHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <div class="mb-3 col-4">
            <label for="celu" class="form-label">Celular</label>
            <input formControlName="celu" id="celu" class="form-control">
            <div id="celuHelp" class="form-text">Nombre del Representante.</div>
        </div>
        <!--<div class="mb-3 col-6">
            <label for="certf1" class="form-label">Certificado 1</label>
            <div class="input-group mb-3">
                <input type="file" class="form-control" id="certf1" formControlName="certf1" accept=".pdf">
            </div>
        </div>
        <div class="mb-3 col-6">
            <label for="certf2" class="form-label">Certificado 2</label>
            <div class="input-group mb-3">
                <input type="file" class="form-control" id="certf2" formControlName="certf2" accept=".pdf"> 
            </div>
        </div>-->
        <div class="mb-3 col-2">
            <button type="submit" class="btn btn-primary">Aceptar</button>
        </div>
    </form>
</div>
